import i18n from "../../src/localization/i18n"
const { t } = i18n.global;

const filtersText = {
    buildings: t('filters.buildings.title'),
    entrances: t('filters.entrances'),
    floors: t('filters.floors'),
    types: t('filters.categories'),
    premiseTypes: t('filters.categories'),
    buildingEntrances: t('filters.entrances'),
    buildingFloors: t('filters.floors'),
    switchgears: t('filters.switchgears'),
    deviceStatuses: t('filters.statuses')
}

function getResultText(qty) {
    let defaultText = t('filters.results.more');

    switch (qty) {
        case 1:
            defaultText = t('filters.results.one');
            break;
        case 2:
        case 3:
        case 4:
            defaultText = t('filters.results.two');
            break;
    }

    return defaultText;
}

function mapActiveFiltersToString(filters) {
    const filterStrings = [];
    const filterKeys = Object.keys(filters);

    filterKeys.forEach((key) => {
        if (filters[key].length) {
            const keyFilter = `${filtersKeyMatch[key]}:${filters[key].join(',')}`;
            filterStrings.push(keyFilter);
        }
    })

    return filterStrings.join(';');
}

const filtersKeyMatch = {
    buildings: 'building_id',
    entrances: 'entrance',
    floors: 'floor',
    types: 'type',
    premiseTypes: 'premise_type',
    buildingEntrances: 'entrance',
    buildingFloors: 'floor',
    switchgears: 'switchgear_id',
    deviceStatuses: 'status',
    states: 'status'
}

const filterKeys = {
    premises: ['buildings', 'entrances', 'floors', 'types'],
    water: ['buildingEntrances', 'buildingFloors', 'deviceStatuses'],
    electricity: ['switchgears', 'buildingEntrances', 'buildingFloors', 'deviceStatuses'],
    balancerSystem: [ 'buildings', 'entrances', 'floors', 'premiseTypes', 'deviceStatuses'],
    elevators: ['buildings', 'entrances', 'floors', 'deviceStatuses'],
    security: ['buildings', 'entrances', 'floors', 'deviceStatuses']
}

function getFiltersByType(type, filters) {
    const keys = filterKeys[type];

    return keys.reduce((acc, key) => {
        return { ...acc, [key] : filters ? filters[key] : [] };
    }, {});
}

export {
    filtersText,
    mapActiveFiltersToString,
    getResultText,
    getFiltersByType
}